module.exports = __webpack_public_path__ + "img/cta_fine.png";